// @flow
import { MantenimientosActionTypes } from './constants';

type MantenimientosAction = { type: string, payload: {} | string };

// common success
export const mantenimientosApiResponseSuccess = (actionType: string, data: any): MantenimientosAction => ({
    type: MantenimientosActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const mantenimientosApiResponseError = (actionType: string, error: string): MantenimientosAction => ({
    type: MantenimientosActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getMantenimiento = (id: string): MantenimientosAction => ({
    type: MantenimientosActionTypes.GET_MANTENIMIENTO,
    payload: { id },
});

// export const listMantenimientos = (contactoId?:string,dataIni?:int,dataFi?:int,productoId?:string): MantenimientosAction => ({
//     type: MantenimientosActionTypes.LIST_MANTENIMIENTOS,
//     payload: {contactoId,dataIni,dataFi,productoId},
// });
export const listMantenimientos = (params:any): MantenimientosAction => ({
    type: MantenimientosActionTypes.LIST_MANTENIMIENTOS,
    payload: params,
});
// export const listInvoicesByClient = (contactoId:string): MantenimientosAction => ({
//     type: MantenimientosActionTypes.LIST_INVOICES_BY_CLIENT,
//     payload: {contactoId},
// });

export const createMantenimiento = (mantenimiento:any):MantenimientosAction=>({
    type:MantenimientosActionTypes.CREATE_MANTENIMIENTO,
    payload:mantenimiento
})
export const updateMantenimiento = (mantenimiento:any):MantenimientosAction=>({
    type:MantenimientosActionTypes.UPDATE_MANTENIMIENTO,
    payload:mantenimiento
})

export const deleteMantenimiento = (id: string):MantenimientosAction=>({
    type:MantenimientosActionTypes.DELETE_MANTENIMIENTO,
    payload:{id}
})

export const resetMantenimientos = (): MantenimientosAction => ({
    type: MantenimientosActionTypes.RESET,
    payload: {},
});

